import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-slurry-breadcrumb-nav',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './slurry-breadcrumb-nav.component.html'
})
export class SlurryBreadcrumbNavComponent {
  @Input() projectName = '';
  @Input() ufid = '';
  @Input() slurryId = 0;

  @Output() dashboardRequested = new EventEmitter<void>();
  @Output() projectRequested = new EventEmitter<void>();

  get slurryLabel(): string {
    const trimmedUfid = this.ufid?.trim();
    if (trimmedUfid) {
      return trimmedUfid;
    }

    return this.slurryId > 0 ? `Slurry #${this.slurryId}` : 'Slurry Details';
  }
}
